import {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  useInfiniteQuery as reactQueryUseInfiniteQuery,
} from 'react-query'

import { formatInfiniteQueryResults } from 'utils/formatResults'
import { Log } from 'utils/logger'

export const useInfiniteQuery = <TData = unknown>(
  key: QueryKey,
  inputFunction: QueryFunction<TData, QueryKey>,
  options?: Omit<
    UseInfiniteQueryOptions<TData, unknown, TData, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) => {
  const queryResults = reactQueryUseInfiniteQuery<TData>(key, inputFunction, {
    onError: (error) => {
      Log.error('useInfiniteQuery onError', error)
    },
    staleTime: 60000,
    ...options,
  })

  return formatInfiniteQueryResults(queryResults)
}
